import React, { useEffect, useState } from "react";
import { Card, Space, Table, Input, Row, Col } from "antd";
import NominaActividadesTable from "./trabajadores/NominaActividadesTable";
import ExportTrabajadoresPDF from "./ExportTrabajadoresPDF";
import ExportInformeEstablecimientoPDF from "./ExportInformeEstablecimientoPDF";
import parser from "../../../../shared/helpers/parser";
import DeleteButton from "../../../../shared/components/deleteButton";
import EditButton from "../../../../shared/components/editButton";
import EstablecimientosApi from "../../../establecimientos/api/EstablecimientosApi";
import Utils from "../../../../shared/helpers/utils";


const NominaTrabajadoresTable = props => {
  const [filteredTrabajadores, setFilteredTrabajadores] = useState(props.Trabajadores);
  const [establecimientosEmpresa, setEstablecimientosEmpresa] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  var trabajadores = props.Trabajadores;

  useEffect(() => {
    EstablecimientosApi.GetEmpresasByCuit(props.cuit).then((response) => { setEstablecimientosEmpresa(response); })
  }, []);

  useEffect(() => {
    setFilteredTrabajadores(props.Trabajadores);
  }, [props.Trabajadores]);

  useEffect(() => {
    const value = searchValue.toLowerCase();
    if (value.length > 0) {
      setFilteredTrabajadores(trabajadores.filter(x => {
        const establecimientoDesc = String(Utils.getIdDesc(x.IdEstablecimientoEmpresa, establecimientosEmpresa) || '').toLowerCase();
        const cuil = String(x.Cuil || '').toLowerCase();
        return establecimientoDesc.includes(value) || cuil.includes(value);
      }));
    } else {
      setFilteredTrabajadores(props.Trabajadores);
    }
  }, [searchValue, props.Trabajadores, establecimientosEmpresa]);

  const getEstablecimiento = id => {
    return props.anexoi.EstablecimientosDeclarados[props.anexoi.EstablecimientosDeclarados.findIndex(x => x.IdEstablecimientoEmpresa == id)]
  }

  return (
    <Card>
      <Row gutter={8} style={{ marginBottom: 16 }}>
        <Col flex="auto">
          <Input
            placeholder="Buscar por establecimiento o CUIL..."
            value={searchValue}
            onChange={e => setSearchValue(e.target.value)}
            style={{ width: '100%' }}
          />
        </Col>
        <Col>
          <ExportTrabajadoresPDF
            filteredTrabajadores={filteredTrabajadores}
            establecimientosEmpresa={establecimientosEmpresa}
            anexoi={props.anexoi}
            anexov={props.anexov}
            cuit={props.cuit}
          />
        </Col>
        <Col>
          <ExportInformeEstablecimientoPDF
            filteredTrabajadores={filteredTrabajadores}
            establecimientosEmpresa={establecimientosEmpresa}
            anexoi={props.anexoi}
            anexov={props.anexov}
            cuit={props.cuit}
          />
        </Col>
      </Row>
      <Table
        style={{ overflow: 'auto' }}
        size="small"
        columns={[
          { title: 'Id', dataIndex: 'IdTrabajador', key: 'IdTrabajador' },
          {
            title: 'Establecimiento Empresa', dataIndex: 'IdEstablecimientoEmpresa', key: 'IdEstablecimientoEmpresa',
            render: text => Utils.getIdDesc(text, establecimientosEmpresa)
          },
          { title: 'Cuil', dataIndex: 'Cuil', key: 'Cuil' },
          { title: 'Fecha Ingreso', dataIndex: 'FechaIngreso', key: 'FechaIngreso', render: text => <span>{parser.date(text)}</span> },
          props.formMode ? {
            title: '', dataIndex: 'Actions', key: 'Actions',
            render: (text, record) => {
              return <Space size="small">
                {
                  props.puedeEditar ?
                  <>
                    <EditButton onClick={() => props.onEdit(record)} />
                    {!record.IdTrabajador ? <DeleteButton onConfirm={() => props.onRemove(record)} /> : ''}
                  </>
                  :null
                }
              </Space>
            }
          } : {},
        ]}
        dataSource={filteredTrabajadores}
        rowKey={(record) => record.Id}
        pagination={{ hideOnSinglePage: true, pageSize: 30, showSizeChanger: false }}
        expandable={{
          expandedRowRender: record => <Card>
            <Card title="Actividades" type="inner" style={{ marginBottom: 16 }}>
              {record.Actividades.length > 0
                ? <NominaActividadesTable
                  Actividades={record.Actividades}
                  puestos={getEstablecimiento(record.IdEstablecimientoEmpresa)?.Puestos}
                  sectores={getEstablecimiento(record.IdEstablecimientoEmpresa)?.Sectores}
                  sustancias={props.anexov.Sustancias}
                />
                : ''}
            </Card>
          </Card>,
        }}
      />
    </Card>

  );
}

export default NominaTrabajadoresTable;